// SPDX-License-Identifier: AGPL-3.0-or-later

const COVER_ID = 'fluxer-locale-transition-cover';
const STYLE_ID = 'fluxer-locale-transition-cover-style';

function ensureCoverStyles(): void {
	if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) {
		return;
	}
	const style = document.createElement('style');
	style.id = STYLE_ID;
	style.textContent = `
#${COVER_ID} {
	position: fixed;
	inset: 0;
	z-index: 2147483647;
	background: var(--background-primary);
	pointer-events: auto;
	cursor: progress;
}
`;
	document.head.appendChild(style);
}

export function showLocaleTransitionCover(): void {
	if (typeof document === 'undefined') {
		return;
	}
	ensureCoverStyles();
	if (document.getElementById(COVER_ID)) {
		return;
	}
	const cover = document.createElement('div');
	cover.id = COVER_ID;
	cover.setAttribute('aria-hidden', 'true');
	cover.setAttribute('data-flx', 'user.locale-transition-cover');
	document.body.appendChild(cover);
}

export function hideLocaleTransitionCover(): void {
	if (typeof document === 'undefined') {
		return;
	}
	document.getElementById(COVER_ID)?.remove();
}
